import { Briefcase, Plane, GraduationCap, HeartHandshake, Building2, FileCheck, ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { SERVICES } from "../data/content";
import { Reveal, SectionHeading, stagger, fadeUp } from "../lib/motion";
import { t } from "../i18n";
import { motion } from "framer-motion";

const ICONS = { Briefcase, Plane, GraduationCap, HeartHandshake, Building2, FileCheck };

export const ServiceCard = ({ service, index }) => {
  const navigate = useNavigate();
  const Icon = ICONS[service.icon] || Briefcase;
  return (
    <motion.div
      variants={fadeUp}
      className="card-lift glass-card rounded-2xl p-8 flex flex-col group cursor-pointer"
      onClick={() => navigate(`/services/${service.slug}`)}
      data-testid={`service-card-${service.slug}`}
    >
      <span className="flex h-14 w-14 items-center justify-center rounded-xl border border-gold/30 bg-gold/10 mb-6 transition-transform duration-500 group-hover:scale-110 group-hover:rotate-3">
        <Icon className="h-6 w-6 text-gold" />
      </span>
      <span className="text-[11px] font-bold tracking-[0.25em] text-slate-500 font-display mb-2">
        {String(index + 1).padStart(2, "0")}
      </span>
      <h3 className="font-display text-xl font-bold text-white mb-3">{service.title}</h3>
      <p className="text-sm text-slate-400 leading-relaxed flex-1">{service.short}</p>
      <span className="mt-6 inline-flex items-center gap-1.5 text-xs font-bold tracking-[0.2em] text-gold font-display">
        {t("services.learnMore")}
        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
      </span>
    </motion.div>
  );
};

const ServicesSection = () => (
  <section id="services" data-testid="services-section" className="relative py-24 lg:py-32 bg-navy overflow-hidden">
    <div className="absolute top-0 left-1/3 h-80 w-80 rounded-full bg-gold/5 blur-3xl" />
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        eyebrow={t("services.eyebrow")}
        title={t("services.title")}
        description={t("services.desc")}
        testid="services-heading"
      />
      <motion.div
        variants={stagger}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-60px" }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
      >
        {SERVICES.map((s, i) => (
          <ServiceCard key={s.slug} service={s} index={i} />
        ))}
      </motion.div>
    </div>
  </section>
);

export default ServicesSection;
